import * as React from 'react'
import { FC } from 'react'

import { ENTITY_TYPES } from '@sales-center/common'
import { SideDrawer } from '@sales-center/components'
import { TableWrapper } from './Table/TableWrapper'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  onClose: () => void
  open: boolean
  canUpdate: boolean
  openAgreementCreateDrawer?: () => void
}

export const ViewAgreementsDrawer: FC<Props> = (props) => {
  const {
    entityId,
    entityType,
    onClose,
    open,
    canUpdate,
    openAgreementCreateDrawer,
  } = props

  return (
    <SideDrawer onClose={onClose} open={open} title={`Agreements`} width={875}>
      <TableWrapper
        entityId={entityId}
        entityType={entityType}
        canUpdate={canUpdate}
        openAgreementCreateDrawer={openAgreementCreateDrawer}
      />
    </SideDrawer>
  )
}

ViewAgreementsDrawer.displayName = 'AgreementsDrawer'
